<template>
  <div class="cellBox">
    <div v-for="(el,index) in colList" :key="index" class="colBox">
      <span class="cellTitle">{{ el.title }}：</span>
      <span class="cellContent">
        <span v-if="el.field == 'seedlingPrice'">
          {{detail.seedlingPrice?.toFixed(2)}}
        </span>
        <span v-else-if="el.field == 'hairyPrice'">
          {{detail.hairyPrice?.toFixed(2)}}
        </span>
        <span v-else-if="el.field != 'area'">
          {{ detail[el.field] || detail[el.field] === 0 ? (Number(detail[el.field]) || Number(detail[el.field]) === 0 ? (len ? Number(detail[el.field]).toFixed(len) : detail[el.field]) : detail[el.field]) : '' }}
        </span>
        <span v-else>{{detail.province}} {{ detail.city }} {{ detail.area }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['colList','detail','len'],
}
</script>